const t = {
  name: "LineHeight",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.00015 1.58594L10.4144 6.00015L9.00015 7.41436L7.00012 5.41434V18.586L9.00015 16.5859L10.4144 18.0002L6.00015 22.4144L1.58594 18.0002L3.00015 16.5859L5.00012 18.5859V5.41439L3.00015 7.41436L1.58594 6.00015L6.00015 1.58594Z" fill="currentColor"/>
<path d="M12.0001 5.00012H22.0001V7.00012H12.0001V5.00012Z" fill="currentColor"/>
<path d="M22.0001 9.00012H12.0001V11.0001H22.0001V9.00012Z" fill="currentColor"/>
<path d="M12.0001 13.0001V15.0001H22.0001V13.0001H12.0001Z" fill="currentColor"/>
<path d="M22.0001 17.0001H12.0001V19.0001H22.0001V17.0001Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as LineHeight
};
